import axios from "axios";
import { Survey } from "../models/Survey";
class SurveyService {
  private readonly baseUrl = "/api/survey";

  public async getSurvey(id: number) {
    const response = await axios.get<Survey>(`${this.baseUrl}/${id}`);
    return response.data;
  }
}

export default new SurveyService();
